import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { styles } from "./styles";
import { STRINGS } from "../../strings";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { BRAND, GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import Typography from "../../../../components/Typography/Typography";
import AllAppData from "./AllAppData";
import ConnectedEspList from "./ConnectedEspList";
import { useSetupWizard } from "../../../../context/SetupWizardContext";

const ApiKeys = () => {
  const classes = styles();
  const { currentStepKey } = useSetupWizard();
  const justConnectedRef = useRef(false);
  const [values, setValues] = useState(() => {
    if (sessionStorage.getItem('__riq_inbox_just_connected')) {
      sessionStorage.removeItem('__riq_inbox_just_connected');
      justConnectedRef.current = true;
      return 1;
    }
    return currentStepKey === "mailbox" ? 2 : 1;
  });
  const headerText = [
    {
      id: 1,
      label: STRINGS.CONNECTED,
    },
    {
      id: 2,
      label: STRINGS.ALLAPPS,
    },
  ];
  const handleChange=(val)=>{
     setValues(val)
  }
  useEffect(() => {
    if (justConnectedRef.current) {
      justConnectedRef.current = false;
      return;
    }
    if (currentStepKey === "mailbox") {
      setValues(2);
    }
  }, [currentStepKey]);

  useEffect(() => {
    const handler = () => {
      sessionStorage.removeItem('__riq_inbox_just_connected');
      justConnectedRef.current = true;
      setValues(1);
    };
    window.addEventListener('riq:inbox-connected', handler);
    return () => window.removeEventListener('riq:inbox-connected', handler);
  }, []);

  const handleConnected = () => {
    setValues(1);
  };
  return (
    <Box className={classes.container}>
      <Box className={classes.scrollContainer}>
        <Box className={classes.apps}>
          <Box className={classes.headerWrap}>
            <TypographyInline
              size={"lg"}
              color={GREY.PRIMARY}
              fontWeight={fontWeight.SEMIBOLD}
              label={STRINGS.CONNECT_WITH_APPS}
            />
            <TypographyInline
              size={"sm"}
              color={GREY.SECONDARY}
              fontWeight={fontWeight.REGULAR}
              label={STRINGS.APP_HEAD}
            />
            <Box className={classes.tabBody}>
            {headerText.map((item) => {
            return (
              <Box
                data-tour={item.id === 2 ? "all-apps-btn" : undefined}
                className={
                  values === item.id ? classes.tabData : classes.tabData1
                }
                onClick={() => handleChange(item.id)}
              >
                <Typography
                  size={"sm"}
                  color={values === item.id ? BRAND.PRIMARY : GREY.SECONDARY}
                  fontWeight={
                    values === item.id
                      ? fontWeight.SEMIBOLD
                      : fontWeight.REGULAR
                  }
                  label={item.label}
                />
              </Box>
            );
          })}
            </Box>
          </Box>
          {values===1 ?
            <ConnectedEspList/>
            :
            <div data-tour="all-apps-grid"><AllAppData onConnected={handleConnected}/></div>
          }
        </Box>
      </Box>
    </Box>
  );
};
export default ApiKeys;